import { createContext } from 'react';

export const LogementContext = createContext();